import { render } from "./NoteReclamation.vue?vue&type=template&id=725f8c7d&scoped=true&ts=true"
import script from "./NoteReclamation.vue?vue&type=script&lang=ts"
export * from "./NoteReclamation.vue?vue&type=script&lang=ts"

import "./NoteReclamation.vue?vue&type=style&index=0&id=725f8c7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725f8c7d"]])

export default __exports__